import { request } from "apis/base";
import { PartnerCreateBodyType, PartnerExportParams, PartnerParamsType, PartnerUpdateBodyType } from "constants/types/partner";

export const partnerApi = {
  getAll: (params?: PartnerParamsType) => {
    return request({ url: "/partner", method: "GET", params });
  },

  export: (params?: PartnerExportParams) => {
    return request({ url: "/partner/export", method: "GET", params, responseType: "blob" });
  },

  getById: (id: string) => {
    return request({ url: `/partner/${id}`, method: "GET" });
  },

  create: (data: PartnerCreateBodyType) => {
    return request({ url: "/partner", method: "POST", data });
  },

  update: (id: string, data: PartnerUpdateBodyType) => {
    return request({ url: `/partner/${id}`, method: "PUT", data });
  },

  delete: (id: string) => {
    return request({ url: `/partner/${id}`, method: "DELETE" });
  },
};
